import { AUTH_TOKEN_STORAGE_KEY } from "./constants/storageConstants";

console.log(process.env);
const getConfig = () => ({
  apiUrl: process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL : "",
  exportUrl: process.env.REACT_APP_OFFER_EXPORT_URL
    ? process.env.REACT_APP_OFFER_EXPORT_URL
    : "",
  getAuthHeader() {
    const authToken = localStorage.getItem(AUTH_TOKEN_STORAGE_KEY);
    return authToken || null;
  },
});
export default getConfig();



// WEBPACK FOOTER //
// ./src/config.js